import * as React from 'react';

import loadable from '@loadable/component';

import { loadableDelay } from '@common/react/loadable/loadableSettings';
import Loader from '@common/react/components/Core/LoadingProvider/Loader';

import { BaseInvite } from '@commonTuna/react/objects/BaseInvite';
import { BaseTemplateSnapshot } from '@commonTuna/react/objects/BaseTemplateSnapshot';

import { User } from '@app/objects/User';

const params = {
	fallback: <Loader />,
};

const ConsentFormSwitcher = loadable(() =>
	loadableDelay(import(/* webpackChunkName: "ConsentFormSwitcher" */ '@commonTuna/react/components/UI/ConsentForm/ConsentFormSwitcher')), params);

interface ComponentProps {
	user: User;
	afterSubmit?: (userData?: User) => void;
	companyTemplateInvites: Array<BaseInvite>;
}

export const SignHipaa: React.FC<ComponentProps> = (props) => {
	const [queryParams, setQueryParams] = React.useState({
		inviteId: 0,
		templateSnapshotId: 0,
		appointmentId: 0,
		patientId: 0,
	});
	const [templateIndex, setTemplateIndex] = React.useState<number>(0);
	const [templateSnapshot, setTemplateSnapshot] = React.useState<BaseTemplateSnapshot | undefined>();

	React.useEffect(() => {
		props.companyTemplateInvites?.length > 0
			? setQueryParams({
				inviteId: props.companyTemplateInvites[0].id,
				templateSnapshotId: props.companyTemplateInvites[0].templateSnapshotId,
				appointmentId: props.companyTemplateInvites[0].appointmentId,
				patientId: props.companyTemplateInvites[0].patientId,
			})
			: props.afterSubmit && props.afterSubmit(props.user);
	}, [props.user, props.companyTemplateInvites]);

	const setNextTemplate = () => {
		const nextTemplateIndex = templateIndex + 1;
		if (nextTemplateIndex < props.companyTemplateInvites.length) {
			setTemplateIndex(nextTemplateIndex);
			setQueryParams({
				inviteId: props.companyTemplateInvites[nextTemplateIndex].id,
				templateSnapshotId: props.companyTemplateInvites[nextTemplateIndex].templateSnapshotId,
				appointmentId: props.companyTemplateInvites[nextTemplateIndex].appointmentId,
				patientId: props.companyTemplateInvites[nextTemplateIndex].patientId,
			});
		} else {
			props.afterSubmit && props.afterSubmit(props.user);
		}
	};

	return <div className="patient-register-page__photo">
		<h4 className="text-center">
			Please sign HIPAA:
			{' '}
			{templateSnapshot ? templateSnapshot.name : ''}
		</h4>
		<h5>{templateSnapshot ? templateSnapshot.description : ''}</h5>
		<h6>
			<strong>Signature required at the bottom - please scroll down</strong>
		</h6>
		{(queryParams.templateSnapshotId > 0)
			? <div className="panel panel-default" style={{ width: '100%', maxWidth: '800px' }}>
				<div className="panel-body" style={{ height: '80vh' }}>
					<ConsentFormSwitcher
						showPdf={false}
						queryParams={queryParams}
						onAccept={() => {
							setNextTemplate();
						}}
						onCancel={() => undefined}
						patientFileId={props.companyTemplateInvites[templateIndex]?.patientFileId}
						enableSave
						getTemplateSnapshot={setTemplateSnapshot}
						showCloseButton={false}
					/>
				</div>
			</div>
			: <Loader />
		}
	</div>;
};
